import type { FaireProductEntity } from "../../entity_types/product";

export const catalog_prod_prod_81: FaireProductEntity = {
  token: "catalog_prod_prod-81",
  type: "product",
  name: "Textile Item",
  brandName: "Audrey's Home & Gift",
  imageUrl:
    "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=400&fit=crop",
  priceDollars: 36.27,
  msrpDollars: 90.68,
  sku: "AN0081",
  caseSize: 1,
  material: "Linen",
  collectionToken: "col_andean-touch",
  isNew: false,
  isBestseller: false,
  isPreviouslyOrdered: false,
  inStock: true,
  stockLevel: 133,
  description: "Beautiful Andean Touch piece perfect for any home.",
  categoryTokens: ["catalog_cat_candles-holders"],
  tags: [],
  brandToken: "catalog_brand_audreys_home_gift",
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
